export default __webpack_public_path__ + "static/media/square-up.b7558b06.jpg";